// extracted by mini-css-extract-plugin
export default {"default":"default__gzmgS","full-width":"full-width__uXrMg"};